var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog210(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210",
    "data-name": 210,
    className: "cls-2",
    d: "M98.28,60.59c4.89-23.37-32.14-40.4-49.94-41.89C27.69,17-15.09,29.31,8.93,56.25c11.12,12.47,27.35,22.16,44.3,24.69C68.15,83.16,94.5,78.58,98.28,60.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog210);
export default __webpack_public_path__ + "static/media/dog_210.99e07e6d27e7fa7329ff28a42a7efa86.svg";
export { ForwardRef as ReactComponent };